<template>
  <div class="holy-places py-10">
    <div class="container mx-auto px-4">
      <h2 class="text-2xl font-bold text-[#222222] mb-4">
        {{ $t("holyPlaces.title") }}
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Мекка -->
        <div
          class="relative rounded-2xl overflow-hidden bg-[#F1F1F1] h-[417px] cursor-pointer"
          v-for="place in holyPlaces"
          :key="place.name"
          @click="() => goToHolyPlace(place.location)"
        >
          <img
            :src="place.image"
            alt="Мекка"
            class="absolute inset-0 w-full h-full object-cover"
          />
          <div
            class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/100 to-transparent"
          >
            <div class="p-8 pb-12">
              <h3 class="text-white text-xl font-semibold mb-1.5">
                {{ place.name }}
              </h3>
              <p class="text-white text-sm">
                {{ place.description }}
              </p>
            </div>
          </div>
          <div class="absolute top-8 right-8">
            <div
              class="w-14 h-14 rounded-full bg-[#3DB076] flex items-center justify-center"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 17L17 7M17 7H8M17 7V16"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "HolyPlaces",
  data() {
    return {
      holyPlaces: [
        {
          name: this.$t("holyPlaces.mecca"),
          description: this.$t("holyPlaces.meccaDescription"),
          image: require("@/assets/images/mecca.png"),
          location: "mecca",
        },
        {
          name: this.$t("holyPlaces.medina"),
          description: this.$t("holyPlaces.medinaDescription"),
          image: require("@/assets/images/medina.png"),
          location: "madinah",
        },
      ],
    };
  },
  methods: {
    goToHolyPlace(location) {
      this.$router.push({ name: "holy_places", query: { location } });
    },
  },
});
</script>

<style scoped>
.holy-places {
  @apply bg-white;
}
</style>
